"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResolutionSelect = exports.TimeSelector = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var react_1 = require("react");
var context_1 = require("../../context/context");
var types_1 = require("../../types");
var NumericInput_1 = __importDefault(require("./NumericInput"));
var styles_1 = require("../../styles");
var SelectMenu_1 = require("./SelectMenu");
var timeArr = [
    {
        text: "minutes",
        value: types_1.TimeResolution.Minutes,
    },
    {
        text: "hours",
        value: types_1.TimeResolution.Hours,
    },
    {
        text: "days",
        value: types_1.TimeResolution.Days,
    },
];
function TimeSelector(_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.className, className = _c === void 0 ? "" : _c, onFocus = _a.onFocus, onBlur = _a.onBlur, _d = _a.placeholder, placeholder = _d === void 0 ? "0" : _d;
    var onResolutionSelect = (0, react_1.useCallback)(function (resolution) {
        onChange({ resolution: resolution, amount: value.amount });
    }, [onChange]);
    return ((0, jsx_runtime_1.jsxs)(StyledContainer, __assign({ className: "twap-time-selector ".concat(className), style: { pointerEvents: disabled ? "none" : "unset" } }, { children: [(0, jsx_runtime_1.jsx)(StyledInput, { onBlur: onBlur, onFocus: onFocus, disabled: disabled, value: value.amount, onChange: function (v) { return onChange({ resolution: value.resolution, amount: Number(v) }); }, placeholder: placeholder }), (0, jsx_runtime_1.jsx)(exports.ResolutionSelect, { resolution: value.resolution, onChange: onResolutionSelect })] })));
}
exports.TimeSelector = TimeSelector;
var ResolutionSelect = function (_a) {
    var onChange = _a.onChange, resolution = _a.resolution, _b = _a.className, className = _b === void 0 ? "" : _b;
    var translations = (0, context_1.useTwapContext)().translations;
    var _c = (0, react_1.useState)(false), open = _c[0], setOpen = _c[1];
    var onSelect = (0, react_1.useCallback)(function (resolution) {
        setOpen(false);
        onChange(resolution);
    }, [onChange]);
    return (0, jsx_runtime_1.jsx)(SelectMenu_1.SelectMenu, { onSelect: function (it) { return onSelect(it.value); }, items: timeArr, selected: resolution });
};
exports.ResolutionSelect = ResolutionSelect;
var StyledInput = (0, styled_components_1.styled)(NumericInput_1.default)({
    flex: 1,
    input: {
        textAlign: "left",
        paddingLeft: 10,
        flex: "unset",
        width: "100%",
        "&::placeholder": {
            color: "white",
        },
    },
});
var StyledContainer = (0, styled_components_1.styled)(styles_1.StyledRowFlex)({});
